module.exports = __webpack_public_path__ + "static/media/ng08.6dafee04.webp";